import React from "react";

const Report = (props) => {
    return <><h1>Report</h1></>
}

export default Report;
